package com.stevdza.san.models

import com.stevdza.san.util.Constants
import com.stevdza.san.util.Res

enum class Likes(
    val image: String,
    val title: String,
    val description: String,
    val url: String,
    var type: Int = 0
) {
    One(
        image = Res.Image.like1,
        title = "45 Graus",
        description = "Podcast",
        url = Constants._45GRAUS_URL
    ),
    Two(
        image = Res.Image.like2,
        title = "Despolariza",
        description = "Podcast",
        url = Constants.DESPOLARIZA_URL
    ),
    Three(
        image = Res.Image.like3,
        title = "Inteligência Emocional",
        description = "Podcast",
        url = Constants.IE_URL
    ),
    Four(
    image = Res.Image.like4,
    title = "Que Treta!",
    description = "Blog",
    url = Constants.KTRETA_URL,
    type = 1
    ),
    Five(
    image = Res.Image.like5,
    title = "Veritasium!",
    description = "Youtube Channel",
    url = Constants.VERITASIUM_URL,
    type = 1
    ),
    Six(
        image = Res.Image.like6,
        title = "Aprende Algo Antes de Dormir",
        description = "Weekly email",
        url = Constants.APRENDE_ALGO_URL,
        type = 1
    ),
    Seven(
        image = Res.Image.like7,
        title = "TLDR News Global",
        description = "Youtube channel",
        url = Constants.TLDR_NEWS_GLOBAL_URL,
        type = 1
    )



}